<template>
  <li class="tache text-regular">
    <div
      class="icons"
      :class="{
        success: tache.succes === true,
        error: tache.succes === false,
      }"
    >
      <slot name="icons" />
    </div>
    <slot name="libelle">
      <div>
        {{ tache.type_tache_verbose }}
      </div>
    </slot>
    <div>
      {{ $moment(tache.date_traitement || tache.date_creation).format($t("global.format-date-hour")) }}
    </div>
  </li>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import Tache from "@/domains/taches/tache";

export default defineComponent({
  name: "TacheButton",
  props: {
    tache: {
      type: Tache,
      required: true,
    },
  },
  methods: {
  },
});
</script>

<style lang="scss">
@use "@lde/core_lde_vue/dist/assets/styles/_variables.scss" as var;

.tache {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var.$space-large;
  .icons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid var.$blue-dark;
    padding: var.$space-xx-tiny;
    border-radius: var.$border-radius-x-tiny;
    &.success {
      border-color: var.$positive;
      color: var.$positive;
    }
    &.error {
      border-color: var.$negative;
      color: var.$negative;
    }
    svg {
      width: var.$space-small;
      height: var.$space-small;
    }
  }
  a:hover {
    text-decoration: underline;
  }
}
</style>
